import { SettingsParser } from "../../settings-parser";
import { ChannelPlotSettings } from "../../../settings/view-objects/plot/channel-plot-settings";
import { getSizeSettings } from "../../../../utils/get-size-settings";
import { getItemByField, ObjectCreator } from "../../../../../../../web-graphics";

export class ChannelPlotSettingsParser extends SettingsParser {
  constructor(configurationParser) {
    super();
    this.parsedFieldNames = [
      "id_channel",
      "showIsolines",
      "y",
      "height",
      "configurations",
      "scaleY",
      "scaleX",
      "filters",
      "isolines", // default configuration field
      "signals", // default configuration field
      "plotContent" // default configuration field
    ];
    this.configurationParser = configurationParser;
  }

  static createSettings(settings, defaultSettings, configurationParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      id_channel: settings.id_channel,
      showIsolines: settings.showIsolines,
      y: getSizeSettings(settings.y, 0, 0),
      height: getSizeSettings(settings.height, 0, 1),
      scaleX: settings.scaleX === undefined ? undefined : ObjectCreator.deepCopy(settings.scaleX),
      scaleY: settings.scaleY === undefined ? undefined : ObjectCreator.deepCopy(settings.scaleY),
      filters: settings.filters === undefined ? undefined : [...settings.filters]
    };
    let configurations = [];
    if (settings.configurations === undefined && (settings.signals !== undefined || settings.isolines !== undefined)) {
      configurations.push({
        name_configuration: "default",
        isolines: settings.isolines,
        signals: settings.signals,
        plotContent: settings.plotContent
      });
    } else {
      configurations = settings.configurations;
    }
    if (configurations !== undefined) {
      parsedSettings.configurations = [];
      for (let configIndex = 0; configIndex < configurations.length; configIndex++) {
        let configurationSettings = configurations[configIndex];
        let defaultConfigSettings = getItemByField("name", configurationSettings.name_configuration, defaultSettings?.configurations);
        let parsedConfiguration = configurationParser.parse(configurationSettings, defaultConfigSettings);
        if (parsedConfiguration !== undefined) {
          parsedSettings.configurations.push(parsedConfiguration);
        }
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = ChannelPlotSettingsParser.createSettings(settings, defaultSettings, this.configurationParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new ChannelPlotSettings(parsedSettings);
  }
}
